import { BoundingBox, Coordinate, Coordinates, MapData } from '@bpd-library/types';

import { PolygonModel } from '../generated';
import {
    calculateBoundingBox,
    calculateBoundingBoxCenter,
    calculateCenter,
    calculateDistance,
    calculateMapDataCenter,
    expandBoundingBox,
    withinBoundingBox,
} from './geometry';

export const TEST_GEOMETRY: {
    coordinates: Coordinates;
    boundingBox: BoundingBox;
    center: Coordinate;
    apiGeometry: PolygonModel[];
} = {
    coordinates: [
        [
            [1, 2],
            [3, 4],
            [1.5, 2.5],
        ],
        [
            [1, 2],
            [3, 4],
            [1.5, 2.5],
        ],
    ],
    boundingBox: [1, 2, 3, 4],
    center: [2, 3],
    apiGeometry: [
        {
            coordinates: [
                [1, 2],
                [3, 4],
                [1.5, 2.5],
            ],
        },
        {
            coordinates: [
                [1, 2],
                [3, 4],
                [1.5, 2.5],
            ],
        },
    ],
};

const MAP_DATA: MapData = [
    {
        id: '1',
        coordinates: TEST_GEOMETRY.coordinates,
        variant: 'default',
    },
    {
        id: '2',
        coordinates: [
            [
                [5, 6],
                [5, 1],
            ],
            [
                [1, 2],
                [8, 9],
            ],
        ],
        variant: 'default',
    },
];

describe('Geometry', function () {
    it('Calculates the correct coordinates boundingBox', function () {
        expect(calculateBoundingBox(TEST_GEOMETRY.coordinates)).toEqual(TEST_GEOMETRY.boundingBox);
    });

    it('Calculates the correct bounding box center', function () {
        expect(calculateBoundingBoxCenter(calculateBoundingBox(TEST_GEOMETRY.coordinates))).toEqual(
            TEST_GEOMETRY.center,
        );
    });

    it('Calculates the correct coordinate center', function () {
        expect(calculateCenter(TEST_GEOMETRY.coordinates)).toEqual(TEST_GEOMETRY.center);
    });

    it('Expands bounding box with 1 km', function () {
        const DEGREE_PER_KM = 0.0089;
        const expandedBoundingBox = [
            1 - DEGREE_PER_KM,
            2 - DEGREE_PER_KM,
            3 + DEGREE_PER_KM,
            4 + DEGREE_PER_KM,
        ];

        expect(expandBoundingBox(TEST_GEOMETRY.boundingBox, 1)).toEqual(expandedBoundingBox);
    });

    it('Boundingbox is within boundingbox', function () {
        expect(withinBoundingBox(TEST_GEOMETRY.coordinates, [0.9, 1.9, 3.1, 4.1])).toBe(true);
    });

    it('Calculates the correct distance between vectors', function () {
        const VECTOR_A: Coordinate = [1, 1];
        const VECTOR_B: Coordinate = [2, 2];

        expect(calculateDistance(VECTOR_A, VECTOR_B)).toEqual(1.4142135623730951);
    });

    it('Calculates correct mapData center', function () {
        expect(calculateMapDataCenter(MAP_DATA)).toEqual([4.5, 5]);
    });
});
